import { toast } from "sonner";

let lastMsg = new Set();

export default function NewToastHandler(stat, msg) {
  const ShowMsg = typeof msg === "string" ? msg : "Invalid message";

  const opt = {
    action: {
      label: "X",
      onClick: () => {
        lastMsg.delete(msg);
      },
    },
    onDismiss: () => {
      lastMsg.delete(msg);
    },
    onAutoClose: () => {
      lastMsg.delete(msg);
    },
    position: "top-right",
    duration: 3000,
    style: {
      maxHeight: "200px",
      overflowY: "auto",
      fontSize: "12px",
      display: "flex",
      alignItems: "flex-start",
    },
  };

  if (!lastMsg.has(msg)) {
    lastMsg.add(msg);
    if (stat === "warn") {
      toast.warning(ShowMsg, opt);
    } else if (stat === "dan") {
      toast.error(ShowMsg, opt);
    } else if (stat === "sus") {
      toast.success(ShowMsg, opt);
    } else {
      toast.info(ShowMsg, opt);
    }
    return true;
  }

  return false;
}
